import { LanguageDto, UpsertLanguageDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/language`;

export const getAllLanguages = (source: CancelTokenSource): Promise<Array<LanguageDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchLanguages = (description: string, source: CancelTokenSource): Promise<Array<LanguageDto>> => {
  return axios
      .get(`${apiUri}?description=${description}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const findLanguageById = (id: number, source: CancelTokenSource): Promise<UpsertLanguageDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then( response => response.data)
};

export const addLanguage = (upsertLanguageDto: Partial<UpsertLanguageDto>, source: CancelTokenSource): Promise<LanguageDto> => {
  return axios
      .post(apiUri, upsertLanguageDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editLanguage = (id: number, upsertLanguageDto: Partial<UpsertLanguageDto>, source: CancelTokenSource): Promise<LanguageDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertLanguageDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteLanguage = (id: number, source: CancelTokenSource): Promise<LanguageDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
